import { render, staticRenderFns } from "./DetailedPagination.vue?vue&type=template&id=c18878ba"
import script from "./DetailedPagination.vue?vue&type=script&lang=js"
export * from "./DetailedPagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports